<mat-drawer-container class="project-detail-content" hasBackdrop="true">
  <mat-drawer #drawer mode="side" position="end" class="drawer position-fixed">

    <div fxLayout="column" class="drawer-margin" fxLayoutGap="26px">
      <span class="drawer-title">Área do Projeto</span>

      <div class="drawer-content" fxLayout="column" fxLayoutGap="50px">
        @if (project.estados.length > 0) {
          <div fxLayout="column" fxLayoutGap="16px">
            <span class="drawer-content-title">Estados</span>
            <div fxLayout="row wrap" fxLayoutGap="12px grid">
              @for (state of project.estados; track state) {
                <div>
                  <mat-chip-option>{{state.descricao}}</mat-chip-option>
                </div>
              }
            </div>
          </div>
        }

        @if (project.regionais.length > 0) {
          <div fxLayout="column" fxLayoutGap="16px">
            <span class="drawer-content-title">Regionais</span>
            <div fxLayout="row wrap" fxLayoutGap="12px grid">
              @for (regional of project.regionais; track regional) {
                <div>
                  <mat-chip-option>{{regional.descricao}}</mat-chip-option>
                </div>
              }
            </div>
          </div>
        }

        @if (project.territorios.length > 0) {
          <div fxLayout="column" fxLayoutGap="16px">
            <span class="drawer-content-title">Territórios</span>
            <div fxLayout="row wrap" fxLayoutGap="12px grid">
              @for (territory of project.territorios; track territory) {
                <div>
                  <mat-chip-option>{{territory.descricao}}</mat-chip-option>
                </div>
              }
            </div>
          </div>
        }

        @if (project.municipios.length > 0) {
          <div fxLayout="column" fxLayoutGap="16px">
            <span class="drawer-content-title">Municípios</span>
            <div fxLayout="row wrap" fxLayoutGap="12px grid">
              @for (municipio of project.municipios; track municipio) {
                <div>
                  <mat-chip-option>{{municipio.descricao}}</mat-chip-option>
                </div>
              }
            </div>
          </div>
        }

      </div>
    </div>

  </mat-drawer>
  <mat-drawer-content>

    <div fxLayout="column" class="project-content">
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div fxLayout="row" fxLayoutGap="8px" class="header">
          <span class="title">
            Projetos
          </span>
        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="10px" style="margin-top: 45px;" (click)="voltarCatalogo()">
        <span class="btn-voltar-catalogo" fxLayoutAlign="start center">
          <span class="material-icons">
            keyboard_arrow_left
          </span>
          Voltar
        </span>
      </div>


      @if (!isLoadingProject) {
        <div class="container-dados-projeto">
          <div class="capa-projeto" style="background-image: url('{{urlCapa}}'), url('{{defCapa}}');">
            <div id="container-banner-projeto">
              <div class="label-projeto">
                <span class="title item-label-projeto">
                  {{project.descricao}}
                </span>
                <span class="subtitle item-label-projeto" style="padding-top: 13px; color: white; font-size: 18px;">
                  {{project.dataAnoref}}
                </span>
              </div>
            </div>
          </div>
          @if (conteudoHTML) {
            <div class="descricao-projeto">
              <span>Descrição</span>
              <div [ngClass]="{'wrapper': descricaoProjetoOverflow && !exibindoDescricaoCompletaProjeto}">
                <div id="texto-html-projeto"
                  [ngClass]="{'overflow-hidden-content': !exibindoDescricaoCompletaProjeto, 'descricao-projeto-expandido': exibindoDescricaoCompletaProjeto}" [innerHTML]="conteudoHTML">
                </div>
              </div>
              @if (descricaoProjetoOverflow) {
                <div style="width: 100%; text-align: end;">
                  @if (!exibindoDescricaoCompletaProjeto) {
                    <span class="btns-crop-descricao-projeto"
                      (click)="expandirDescricaoProjeto()" fxLayoutAlign="end center">
                      Ver mais
                      <span class="material-icons">
                        keyboard_arrow_down
                      </span>
                    </span>
                  }
                  @if (exibindoDescricaoCompletaProjeto) {
                    <span class="btns-crop-descricao-projeto"
                      (click)="recolherDescricaoProjeto()" fxLayoutAlign="end center">
                      Ver menos
                      <span class="material-icons">
                        keyboard_arrow_up
                      </span>
                    </span>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
      @if (isLoadingProject) {
        <div class="">
          <app-loading-spinner></app-loading-spinner>
        </div>
      }


      <div class="tabs" style="padding-top: 30px;">
        <mat-tab-group (click)="mudaAba(selected.value)" [selectedIndex]="selected.value"
          (selectedIndexChange)="selected.setValue($event)">

          <mat-tab label="Vocação e Potencial" id="1">
            <div>
              @if (mostraHtml) {
                <div fxLayout="column" fxLayoutGap="40px">
                  <div fxLayout="column">
                    <span class="title">Vocações</span>
                    @if (!isLoadingVocacao) {
                      <app-vocacao-table-public [submitProjectObj]="project" [canChange]="false"
                      [loadListTrigger]="loadListTrigger" [updateOnCheck]="true"></app-vocacao-table-public>
                    }
                    @if (isLoadingVocacao) {
                      <app-loading-spinner></app-loading-spinner>
                    }
                  </div>
                  <div fxLayout="column">
                    <span class="title">Potenciais</span>
                    @if (!isLoadingPotencial) {
                      <app-potenciais-table-public [submitProjectObj]="project" [loadListTrigger]="loadListTrigger"
                      [updateOnCheck]="true"></app-potenciais-table-public>
                    }
                    @if (isLoadingPotencial) {
                      <app-loading-spinner></app-loading-spinner>
                    }
                  </div>
                </div>
              }
            </div>
          </mat-tab>
          <mat-tab label="Análise" id="1">
            <div fxLayout="column">
              <span class="title">Análise</span>
              <app-project-details-analise-public [project]="project" [memberList]="memberList">
              </app-project-details-analise-public>
            </div>
          </mat-tab>
          <mat-tab label="Setores Prioritários" id="2">
            <div fxLayout="column">
              <span class="title">Setores Prioritários</span>
              <app-setores-prioritarios-public [project]="project" [memberList]="memberList">
              </app-setores-prioritarios-public>
            </div>
          </mat-tab>

          <mat-tab label="Maturidade" id="3">
            <ng-template matTabContent>
              <app-detalhes-maturidade-public [project]="project"></app-detalhes-maturidade-public>
            </ng-template>
          </mat-tab>

          <mat-tab label="Planos de Ação" id="4">
            <div fxLayout="column">
              <app-planos-acao-project-public [project]="project" [memberList]="memberList">
              </app-planos-acao-project-public>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>